import { markSearchSubmit } from '@/utility/tracking/searchWaitTime';
import { tracker } from '@/utility/tracking/tracker';
import { SearchBarSource } from '@/utility/tracking/types';

/**
 * Search-bar only. PLP page tracking also has `search.term`, including landings from Google, so
 * this event is what tells a header submit or suggestion pick from a prefilled URL. It also starts
 * the search wait time, which the results page ends.
 */
export const trackSearchBar = (term: string, source: SearchBarSource) => {
  if (!term) return;

  markSearchSubmit(source);
  tracker.trackFeature({
    featureUsed: 'search-bar',
    detail: { term, source },
  });
};

/** The shopper focused the search field: click, tap or keyboard. No payload — the open is the event. */
export const trackSearchBarOpen = () => {
  tracker.trackFeature({ featureUsed: 'search-bar-open', detail: {} });
};

/** The empty-field trending searches and popular licenses became visible (DEV-234005). */
export const trackTrendingSearchesShown = (variant: 'data' | 'marketing') => {
  tracker.trackFeature({
    featureUsed: 'search-bar-trending-shown',
    detail: { variant },
  });
};
